import { render, staticRenderFns } from "./BackgroundCriminalHistory.vue?vue&type=template&id=285442e5"
import script from "./BackgroundCriminalHistory.vue?vue&type=script&lang=ts"
export * from "./BackgroundCriminalHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports